
    <cm-domain-status-circle [status]="status" [showTooltip]="false"></cm-domain-status-circle>
    <span>
      {{DomainStatusLabels[status]}}
      <span *ngIf="rejectReason&&status===DomainStatus.REJECTED">
        <i class="far fa-info-circle ml-2 text-info" [matTooltip]="rejectReason"></i>
      </span>
      <span *ngIf="test">- test</span>
    </span>
  